export const kanbanTemplate = {
      "kanbancolumns": [],
      "groupFields": [],
      "groupOptionalFields": [],
      "typeLabel": "",
      "enableOptions": true,
      "gradient": true,
      "readOnly": false,
      "enableDashboard": true,
      "showInboardChart": true,
      "titleField": "DATE_FIELD",
      "fieldAlignTitle": "text-left",
      "subTitleField": "TEXT_FIELD"
    }